import { I4BColumnConfiguration } from '../configurations/i4b-column-configuration';
import { I4BColumnHeader } from '../models/i4b-column-header.model';
import { I4BColumnOptions } from '../options/i4b-column-options';
import { TotalColumn } from './i4b-total.column';

export class TotalContactsColumn extends TotalColumn {
  columnId = 'b8f7bf72-5c1e-11ec-80a5-0023a40210d0-total-contact';
  className = TotalContactsColumn;

  constructor(customHeader: Partial<I4BColumnHeader> | undefined, customConfig: Partial<I4BColumnConfiguration>, customOptions?: Partial<I4BColumnOptions>) {
    super(
      { displayName: 'TOTAL CONTACTS', icon: 'person', ...customHeader },
      {
        ...customConfig,
        id: customConfig.id ? customConfig.id : 'totalContacts',
        isDefault: true
      },
      { customId: customConfig.id ? customConfig.id : 'totalContacts', ...customOptions }
    );
  }
}
